import { Component, OnInit } from '@angular/core';
import _ from 'lodash';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';



@Component({
  selector: 'app-codigo-descuento',
  templateUrl: './codigo-descuento.component.html',
  styleUrls: ['./codigo-descuento.component.scss']
})
export class CodigoDescuentoComponent implements OnInit{
  discountCode: string;
  appliedDiscountCode: string;
  errorMessage: string;

  constructor(
    private carroService: CarroComprasService,
    private productoService: vmProductosService,
    private tagManagerService: TagManagerService
  ) { }

  public async aplicarDescuento(codigoDescuento: string) {
    this.productoService.validarDescuento(codigoDescuento).subscribe((resp: any) => {
      if (resp.data.estado === true) {
        const descuento = resp.data;
        descuento.codigo = codigoDescuento;
        this.carroService.aplicarDescuento(descuento);
        const price = this.calculoPrice();
        this.appliedDiscountCode = codigoDescuento;
        const eventoCupon = GoogleTagManager.eventInteracciones().categoriaResumenCompra(codigoDescuento,String(price));
        this.tagManagerService.logEvent(eventoCupon);
        console.log("codigo es: " + codigoDescuento);
        this.resetFormControl();
      } else {
        this.errorMessage = 'Código inválido';
      }
    }, (error) => {
      this.errorMessage = "Error al aplicar descuento";
    });
  }

  ngOnInit(): void {
    // Esperar 3 segundos y luego pausar la animación
    setTimeout(() => {
      const enter: HTMLElement | null = document.getElementById('enter');
      if (enter) {
        enter.classList.add('pausa');
      }
    }, 9000);
  }

  public removerCodigoDescuento() {
    this.carroService.removerCodigoDescuento();
    this.appliedDiscountCode = undefined;
  }

  private resetFormControl() {
    this.errorMessage = undefined;
    this.discountCode = undefined;

  }
  private calculoPrice (){
    const product = this.carroService.getCurrentProduct();
    const cantidad = Number(_.get(product, 'cantidad', '1') === '' ? '1' : _.get(product, 'cantidad', '1'));
    const amount = _.get(product, 'amount', '0') === null ? '0' : _.get(product, 'amount', '0').replace('.', '');
    let price = 0;
    if (amount > 0) {
        price = amount / cantidad;
    }
    return price
  }
}
